var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.url),expression:"url"}],staticClass:"video-player",on:{"click":_vm.onClick}},[_c('div',{attrs:{"id":"video_player"},on:{"click":function($event){$event.stopPropagation();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }